module.exports = __webpack_public_path__ + "media/schneeflöckchen.6bc3e321.mp3";